import React, { useMemo } from "react";
import Chat from "../chat";
import useBaseRequest from "@/hooks/useBaseRequest";
import {
    getInitData,
} from "@/api/index";
import { utils } from "@sui/runtime";
import { useEmbedOptions } from "@/components/EmbedWelcome";

function Merge(props) {
    const { single, ...others } = props
    const {
        runAsync: requestInit,
        loading: loadingInitData,
        data: initData,
    } = useBaseRequest(() => getInitData({}), {
        // manual: true,
        onSuccess(res) { },

    });

    // 通过url参数判断是否为嵌入的页面
    const embed = useMemo(() => {
        const _embed = utils.getQueryParam('embed')
        return _embed == '1' || _embed == 'true'
    }, [])

    // 获取嵌入配置
    const embedOptions = useEmbedOptions()

    console.log(initData, "初始化数据")
    return initData?.data?.enabledagents && !single ? <>
        {
            window.location.hash.includes("single") ? <>
                <Chat {...others} single={single} mode={"single"} embed={embed} embedOptions={embedOptions} />
            </> : <Chat {...others} mode={"multiple"} embed={embed} embedOptions={embedOptions} />
        }
    </> : <Chat {...others} single={single} mode={"single"} embed={embed} embedOptions={embedOptions} />
}

export default Merge